import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'

const timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/

export const updateRecurrentIncomeSchema = z
  .object({
    name: z.string().min(1).max(100),
    amount: z.number().nonnegative().nullable(),
    currency: z.nativeEnum(Currency),
    dayOfMonth: z.number().int().min(1).max(31),
    creationTime: z.string().regex(timeRegex, 'Must be HH:mm'),
    accountId: z.string().guid(),
    categoryId: z.string().guid(),
    description: z.string().max(500).nullable(),
    notifyDaysBefore: z.number().int().min(1).max(30).nullable(),
    notifyTime: z.string().regex(timeRegex, 'Must be HH:mm').nullable(),
    notifyMessage: z.string().max(500).nullable(),
    endDate: z.string().datetime().nullable(),
    active: z.boolean(),
  })
  .partial()
  // partial PATCH: only reject the in-request inconsistency (setting notifyDaysBefore while
  // EXPLICITLY clearing notifyTime to null). a PATCH that sets only notifyDaysBefore must pass so it
  // reaches the service, which validates the merged record against the already-stored notifyTime —
  // `== null` also caught `undefined` and 400'd those valid partials at the pipe. (#305) (#282 twin)
  .refine((data) => !(data.notifyDaysBefore != null && data.notifyTime === null), {
    message: 'notifyTime is required when notifyDaysBefore is set',
    path: ['notifyTime'],
  })

export type UpdateRecurrentIncomeDto = z.infer<typeof updateRecurrentIncomeSchema>
